/**
 * Which form the owner sign-in should open on, chosen on the Welcome screen.
 *
 * "Sign in" and "Create account" both hand over to the same owner portal; this
 * carries the choice across that hand-over so "Create account" lands on the
 * sign-up form instead of the login. sessionStorage, not a URL param: the
 * installed app never changes its URL, and ?register=true already means
 * "arrived from a document e-mail" to AuthForm.
 */
const KEY = 'welcome_open_signup';

export function requestSignup(): void {
  try {
    sessionStorage.setItem(KEY, '1');
  } catch {
    /* private mode — the login still opens, one tap from sign-up */
  }
}

export function signupRequested(): boolean {
  try {
    return sessionStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

/** Read once, then cleared, so a later visit opens on the login again. */
export function clearSignupRequest(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
